import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Link } from '../../../../../CommonComponents/OPL/Link/Link';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { IntegrationInfo } from '../IntegrationInfo/IntegrationInfo';
import { IntegrationDTO } from '../../api/useIntegrationsSettingsQuery';

const website = 'https://www.schwab.com/';

interface Props {
  integration: IntegrationDTO;
  onClose(): void;
}

export const CharlesSchwab = ({ integration, onClose }: Props) => {
  return (
    <Modal isOpen onRequestClose={onClose} aria={{ labelledby: 'modal-header' }}>
      <ModalHeader as="h2" id="modal-header">
        {integration.Label}
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <IntegrationInfo integration={integration} website={website} />

        <Box display="flex" flexDirection="column" alignItems="center" css={{ gap: '8px' }} mt="16">
          <Text>
            To link your Schwab Institutional account with Orion Planning (such that all of your
            client accounts in custody at Schwab are automatically linked to the Orion Planning
            platform), take the following steps:
          </Text>

          <ol>
            <li>
              <Text>
                Call Schwab Technical Client Service at{' '}
                <Link href="tel:+18006475465">1 800 647 5465</Link>, and ask them for a Third Party
                Letter to share their data with Orion Planning (you must mention Orion Planning
                specifically).
              </Text>
            </li>
            <br />
            <li>
              <Text>
                They will send a form to you (the advisor) and a form to Orion Planning, which you
                must fill out with your master account codes and email to us at{' '}
                <Link href="mailto:financialplanning@orion.com">financialplanning@orion.com</Link>
                . Add the bottom of the letter, you must also add to the request:
                <br />
                <br />
                &ensp;&ensp; Include SSNs with all ACC files
              </Text>
            </li>
            <br />
            <li>
              <Text>
                We will use these numbers on our corollary form, faxing in both to Schwab and
                awaiting their institutional confirmation.
              </Text>
            </li>
            <br />
            <li>
              <Text>
                Orion Planning&apos;s tech team will then liaise with Schwab&apos;s tech team and we
                will take over the process to establish, test and confirm the data links, notifying
                you several days later when complete.
              </Text>
            </li>
          </ol>
        </Box>
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button ml="8" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
